import { useQuery } from '@tanstack/react-query';
import { sourceService, type SourceType } from '../services/source.service';

export function useSourceTypes() {
  return useQuery<SourceType[]>({
    queryKey: ['sourceTypes'],
    queryFn: () => sourceService.getSourceTypes(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

